/**
 * Feature flags for toggling UI features on/off.
 * Set to false to hide the feature from the UI entirely.
 */
export const FEATURES = {
  /** Strategy optimizer (AI evolution) — disabled until backend is functional */
  OPTIMIZER: false,
  /** Video catalog — YouTube-hosted product videos */
  VIDEO_CATALOG: false,
} as const;
